<template>
    <Navbar :title="'立项查询结果'"></Navbar>
    <!-- <div class="box">
        <div class="company">{{ company }}</div>
        <div class="totla-box">共 <span class="total-num">{{ listTotal }}</span> 条记录</div>
    </div> -->
    <van-search
            v-model="company"
            show-action
            placeholder="请输入搜索关键词"
            @search="onSearch"
            shape='round'
        >
        <template #action>
            <div @click="onSearch">
                <van-button size='small' type="primary">搜索</van-button>  
            </div>
        </template>
    </van-search>
    <van-empty description="暂无数据" v-show="emptyShow" />
    <van-list v-model="loading" :finished="finished" @load="onSearch" finished-text="没有更多了" v-if="!emptyShow" offset="0">
        <div class="policy-file-item" v-for="record in list" :key="record">
            <div class="content">
            <div><span class="label">政策名称：</span>{{record._PolicyName}}</div>
            <div><span class="label">申报单位：</span>{{record._CompanyName}}</div>
            <div><span class="label">项目类型：</span>{{record._ProjectType}}</div>
            <div><span class="label">所属口径：</span>{{record._Source}}</div>
            <div><span class="label">立项时间：</span>{{record._ApprovalDate}}</div>
            <div v-if="record._ApprovalAmount"><span class="label">立项金额：</span><span class="amount">{{record._ApprovalAmount}}万元</span></div>
            </div>
        </div>
    </van-list>
</template>
<script>
import axios from 'axios'
import Navbar from '@/components/Navbar'
export default {

    data() {

        return {
            list: [],
            loading: false,
            finished: false,
            listTotal:0,
            company:'',
            emptyShow: false
        }
    },
    components: { Navbar, },
    computed: {},

    mounted() {
        this.company = this.$route.query.company
    },
    watch: {},
    methods: {
        async onSearch() {
            this.loading = true
            axios.get('/app/lxcx/lists',{
                params:{
                    company:this.company
                }
            }).then((re)=>{
                let res = re.data
                if(res.status != 0){
                    return false
                }
                if(res.result.result == 'fail'){
                    this.$toast({message:res.result.msg})
                    return false
                }
                if(res.result.tablerecord){
                    this.list = res.result.tablerecord || []
                    this.listTotal = res.result.recordcount
                    this.emptyShow = !res.result.tablerecord.length ?true : false
                }else{
                    this.list = []
                    this.listTotal = 0
                    this.emptyShow = true
                }
            }).finally(()=>{
                this.loading = false
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    margin: 20px 0;
    text-align: center;
    font-size: 16px;

    .company {
        font-size: 20px;
        margin-bottom: 5px;
    }

    
}
.content{
    padding:15px;
    font-size: 14px;
    line-height: 20px;
    .label{
        font-weight: 600;
        color: #6aa6e2;
    }
    .amount {
        color: #d01414;
        font-weight: 600;
    }
}
</style>
